/** Triggers a browser file download for a given Blob/ArrayBuffer/string. */
export function downloadFile(data: BlobPart, fileName: string, mimeType: string): void {
  const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // Release the object URL after the click has been processed.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
